import React from 'react';
import * as PropTypes from 'prop-types';
import { ElementWrapper, CancelButton, OkButton } from './elements';

function Sef003(props) {
  return (
    <ElementWrapper className={props.className}>
      <CancelButton onClick={props.onCancel}>
        {props.cancelButtonText}
      </CancelButton>
      <OkButton disabled={props.disabled} onClick={props.onClick}>
        {props.okButtonText}
      </OkButton>
    </ElementWrapper>
  );
}

Sef003.propTypes = {
  cancelButtonText: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  okButtonText: PropTypes.string,
  onCancel: PropTypes.func,
  onClick: PropTypes.func,
};
export default Sef003;
